"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => {};

/** True after hydration, false during server render. */
export function useIsClient() {
  return useSyncExternalStore(subscribe, () => true, () => false);
}
